import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, from } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { customFetch } from './customFetch';

import { graphqlEndpoint } from '../config';

export class ApolloClientFactory {
    private static instance: ApolloClient<NormalizedCacheObject>;

    public static GetClient() {
        if (this.instance == undefined) {
            const httpLink = createHttpLink({
                uri: graphqlEndpoint,
                fetch: (global as any).SSR ? require('node-fetch').default : customFetch
            });

            const authMiddleware = new ApolloLink((operation, forward) => {
                operation.setContext({
                    headers: {  
                        'Accept-Encoding': 'gzip',
                        Authorization: localStorage.getItem('token') ? `${localStorage.getItem('token')}` : null,
                        'Auth0-Authorization': localStorage.getItem('auth0accessToken') ? localStorage.getItem('auth0accessToken') : null,
                    }
                });

                return forward ? forward(operation) : null;
            });

            this.instance = new ApolloClient({
                link: from([authMiddleware, httpLink]),
                cache: new InMemoryCache().restore((window as any).__APOLLO_STATE__)
            });
        }

        return this.instance;
    }
}



// WEBPACK FOOTER //
// ./src/domain/apolloClientFactory.ts